import React, { useState } from 'react';
import { IconButtonProps } from './IconButton.types';
import { getIconButtonStyles } from './styleUtils';
import { Loader } from 'react-feather';
import { theme } from './theme';
import './IconButton.css';

const IconButton: React.FC<IconButtonProps> = ({
	onClick,
	loading,
	disabled,
	color,
	size,
	icon,
	circle,
	ariaLabel,
	type = 'button',
	dataTestId
}) => {
	const [isFocused, setIsFocused] = useState(false);
	const dynamicStyles = getIconButtonStyles(theme, size, color);
	const componentStyles = () => {
		const baseStyles = dynamicStyles.iconButton_css;
		const focusedStyles =
			isFocused && color !== 'error' && color !== 'destroy_secondary'
				? dynamicStyles.iconButtonFocused_css
				: {};
		const errorFocusedStyles =
			isFocused && (color === 'error' || color === 'destroy_secondary')
				? dynamicStyles.destroyFocused_css
				: {};
		const circleStyles = circle ? dynamicStyles.circle_css : {};
		return {
			...baseStyles,
			...focusedStyles,
			...errorFocusedStyles,
			...circleStyles
		};
	};

	if (loading) {
		return (
			<button
				data-testid={dataTestId}
				type={type}
				disabled={true}
				className={`icon-button`}
				style={componentStyles()}
				aria-label={ariaLabel}
				aria-disabled={true}
			>
				<Loader size={16} className="spin-animation" data-testid="loading-icon" />
			</button>
		);
	}
	return (
		<button
			data-testid={dataTestId}
			type={type}
			onClick={onClick}
			disabled={disabled}
			aria-label={ariaLabel}
			aria-disabled={disabled}
			className={`icon-button`}
			style={componentStyles()}
			onFocus={() => setIsFocused(true)}
			onBlur={() => setIsFocused(false)}
		>
			{icon}
		</button>
	);
};

export default IconButton;
